export const APP_NAME = "Renk8Rooms";
export const APP_TAGLINE = "Private rooms for you and your friends.";

export const TRIFECTA_PALETTE = {
  bgDeep: "#181818",
  bgSurface: "#1F1F1F",
  border: "#444444",
  accent: "#E2843B",
  accentLight: "#EFB080",
  textMuted: "#BBBBBB",
  text: "#DADADA",
  textSubtle: "#787878",
} as const;
